<template>
    <div>
        <title-edit header="Online exhibition"/>
        <line-hr/>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                &nbsp;
            </v-col>
            <v-col cols="12" sm="8">
                <v-app class="switch-app">
                    <v-switch label="Publish" v-model="form.is_publish"></v-switch>
                </v-app>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Branch</label>
            </v-col>
            <v-col cols="12" sm="8">
                <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Exhibition name TH*</label>
            </v-col>
            <v-col cols="12" sm="8">
                <input-text-field :model="form.title_th" @update="updateTitleTH"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Exhibition name EN*</label>
            </v-col>
            <v-col cols="12" sm="8">
                <input-text-field :model="form.title_en" @update="updateTitleEN"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Description TH*</label>
            </v-col>
            <v-col cols="12" sm="8">
                <input-editor :model="form.detail_th" @update="updateDetailTH"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Description EN*</label>
            </v-col>
            <v-col cols="12" sm="8">
                <input-editor :model="form.detail_en" @update="updateDetailEN"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Slug Url</label>
            </v-col>
            <v-col cols="12" sm="8">
                <input-text-field :model="form.slug_url" @update="updateSlugUrl"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Upload Exhibition</label>
            </v-col>
            <v-col cols="12" sm="9" xs="12">
              <v-row>
                <v-col cols="12" md="8">
                  <file-upload
                          ref="upload"
                          :directory="true"
                          :multiple="true"
                          @input-filter="inputFilter"
                  >
                    Choose directory
                  </file-upload>
                </v-col>
                <v-col cols="12" md="2">
<!--                  <v-btn label="Upload Files" @click.native="uploadFiles"/> 607d8b fb8c00-->
                    <v-btn
                            :loading="loading5"
                            :disabled="loading5"
                            color="#fb8c00"
                            class="ma-2 white--text"
                            fab
                            small
                            @click="uploadFiles"
                    >
                        <v-icon dark style="color: white">
                            mdi-cloud-upload
                        </v-icon>
                    </v-btn>
                </v-col>
              </v-row>
                <v-row>
                    <v-col cols="12" md="8">
                        <ul v-if="multiFiles" style="list-style-position:inside;list-style-type:circle;">
                            <li v-for="file in multiFiles">
                                {{file.name}}
                            </li>
                        </ul>
                    </v-col>
                </v-row>
              <v-row v-if="files && files[0]">
                <v-col cols="12" sm="8">
                  <input-text-field :model="files[0].relative_path" @update="updateAttachedWebsiteTH"/>
                </v-col>
                <v-col cols="12" md="2">
                  <submit-button label="preview" @click.native="downloadUrl(files[0].preview)"/>
                </v-col>
              </v-row>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Attached website TH</label>
            </v-col>
            <v-col cols="12" sm="9" xs="12">
                <v-row>
                    <v-col cols="12" md="8">
                        <input-text-field :model="form.attached_website_th" @update="updateAttachedWebsiteTH"/>
                    </v-col>
                    <v-col cols="12" md="2">
                        <submit-button label="preview" @click.native="downloadUrl(form.display_attached_website_th)"/>
                    </v-col>
                </v-row>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Attached website EN</label>
            </v-col>
            <v-col cols="12" sm="9" xs="12">
                <v-row>
                    <v-col cols="12" md="8">
                        <input-text-field :model="form.attached_website_en" @update="updateAttachedWebsiteEN"/>
                    </v-col>
                    <v-col cols="12" md="2">
                        <submit-button label="preview" @click.native="downloadUrl(form.display_attached_website_en)"/>
                    </v-col>
                </v-row>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Template*</label>
            </v-col>
            <v-col cols="12" sm="8">
                <select-option :items="optionTemplate" :model="form.template_id" @update="updateTemplate"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Publish date*</label>
            </v-col>
            <v-col cols="12" sm="8">
                <date-picker :model.sync="form.publish_date" @update="updatePublishDate"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Background color</label>
            </v-col>
            <v-col cols="12" sm="8">
                <a @click="showModalSelectColor">
                    <v-icon :color="form.background_color" style="font-size: 50px">
                        fas fa-square
                        <span>click select color</span>
                    </v-icon>
                </a>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Cover image name</label>
            </v-col>
            <v-col cols="12" sm="8">
                <input-text-field :model="form.cover_image_name" @update="updateCoverImageName"/>
            </v-col>
        </div>
        <div class="row">
            <v-col cols="12" sm="3" class="label">
                <label>Cover image cover*</label>
                <div style="color: #2E8037; font-size: 12px">
                    *รองรับ JPEG ,PNG <br>ขนาดไฟล์ 1,200 x 628 px ไม่เกิน 500KB
                </div>
            </v-col>
            <v-col cols="12" sm="8">
                <input-image-upload id="image1" width="200px" height="150px" :model="form.cover_image_path"
                                    :error-size="'500'"
                                    @update="updateCoverImage"/>
            </v-col>
        </div>
        <line-hr/>
        <command-button @delete-info="deleteData" @save-info="saveData" @save-close="saveClose"></command-button>
        <v-dialog
                ref="dialog"
                v-model="modal"
                persistent
                width="290px">
            <div style="background-color: #1d2024">
                <select-color @update="updateBackgroundColor"/>
            </div>
        </v-dialog>
    </div>
</template>

<script>
    import TitleEdit from "../../../components/TitleHeader/TitleEdit";
    import LineHr from "../../../components/Icon/line-hr";
    import SelectOption from "../../../components/Input/selectOption";
    import InputTextField from "../../../components/Input/InputTextField";
    import DeleteButton from "../../../components/Button/DeleteButton";
    import PreviewButton from "../../../components/Button/PreviewButton";
    import SaveButton from "../../../components/Button/SaveButton";
    import DatePicker from "../../../components/Input/DatePicker";
    import SelectColor from "../../../components/Input/SelectColor";
    import InputImageUpload from "../../../components/Input/InputImageUpload";
    import {mapState} from "vuex";
    import InputEditor from "../../../components/Input/InputEditor";
    import {permissionOnlineExhibition, role} from "../../../util/Permission";
    import Swal from "sweetalert";
    import InputUploadFile from "../../../components/Input/InputUploadFile";
    import SubmitButton from "../../../components/Button/SubmitButton";
    import {url} from "../../../util/Constants";
    import Service from "../../../Services";
    import CommandButton from "../../../components/Layout/CommandButton";

    export default {
        name: "OnlineExhibitionEdit",
        components: {
            CommandButton,
            SubmitButton,
            InputUploadFile,
            InputEditor,
            InputImageUpload,
            SelectColor,
            DatePicker,
            SaveButton,
            PreviewButton, DeleteButton,
            InputTextField, SelectOption, LineHr, TitleEdit
        },
        computed: {
            permissionOnlineExhibition,
            ...mapState({
                form: state => {
                    return state.OnlineExhibition.form;
                }
            })
        },
        data() {
            return {
                files: [],
                modal: false,
                optionBranch: [],
                optionTemplate: [
                    {value: '', text: 'Select Template'},
                    {value: 1, text: '1'},
                    {value: 2, text: '2'},
                ],
                permission: null,
                multiFiles: [],
                loader: null,
                loading5: false,
                save_id: null
            }
        },
        created() {
            this.permission = role;
            this.getBranchData();
        },
        watch: {
            // loader () {
            //     const l = this.loader
            //     this[l] = !this[l]
            //
            //     console.log(this[l])
            //     setTimeout(() => (this[l] = false), 3000)
            //
            //     this.loader = null
            // },
        },
        methods: {
            uploadFiles() {
                this.loader = 'loading5';
                this.loading5 = !this.loading5;
                // const l = this.loader
                // this[l] = !this[l]

                let file = this.multiFiles;
                if (file.length > 0) {
                    const filePathWithName = file[0].name.split('/');
                    const filePath = filePathWithName[0];
                    const fileName = filePathWithName[1];
                    const formData = new FormData();
                    formData.append('folder', filePath);
                    let index = 0;
                    for (const item of file) {
                        var keyFile = 'files[' + index + ']';
                        var keyPath = 'paths[' + index + ']';
                        formData.append(keyFile, item.file);
                        formData.append(keyPath, item.name);
                      index++;
                    }
                    Service.UtilityAPI.getUploadFilesPath(formData)
                        .then(response => {
                          this.files = response
                            if(this.files && this.files[0]){
                                this.form.attached_website_th = this.files[0].relative_path
                                this.form.display_attached_website_th = this.files[0].preview
                                this.form.attached_website_en = this.files[0].relative_path
                                this.form.display_attached_website_en = this.files[0].preview
                                this.loader = null
                                this.loading5 = false
                            }
                        }).catch(() => {
                        Swal('', 'Failed to upload file', 'error');
                        this.loader = null
                        this.loading5 = false
                    });

                } else {
                    this.loader = null
                    this.loading5 = false
                }
            },
            /**
             * Pretreatment
             * @param  Object|undefined   newFile   Read and write
             * @param  Object|undefined   oldFile   Read only
             * @param  Function           prevent   Prevent changing
             * @return undefined
             */
            inputFilter: function (newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    this.multiFiles.push(newFile)
                }
            },
            getBranchData() {
                this.$store.dispatch("Branch/getBranchAll").then(res => {
                    this.optionBranch = [
                        {text: "Select", value: ""},
                        ...res.filter(val => val.branch_id !== 0).map(type => ({
                            value: type.branch_id,
                            text: type.branch_name_th + " (" + type.branch_name_en + ")"
                        }))
                    ];
                });
            },
            showModalSelectColor() {
                this.modal = true;
            },
            saveClose() {
                if (!this.form.detail_th) {
                    Swal('', 'Please insert Detail TH !', 'error');
                    return false;
                }
                if (!this.form.detail_en) {
                    Swal('', 'Please insert Detail EN !', 'error');
                    return false;
                }
                if (!this.form.template_id) {
                    Swal('', 'Please select Template !', 'error');
                    return false;
                }
                if (!this.form.publish_date) {
                    Swal('', 'Please select Publish Date !', 'error');
                    return false;
                }
                if (!this.form.cover_image_path) {
                    Swal('', 'Please select Cover Image !', 'error');
                    return false;
                }
                this.$store.dispatch("OnlineExhibition/saveOnlineExhibition", {
                    id: this.save_id ? this.save_id : this.form.id,
                    data: this.form
                }).then(res => {
                    Swal(res.response_msg)
                    if (res.response_code == 200) {
                        this.goToTable();
                    }
                }).catch(() => {
                    Swal('', 'Cannot save online exhibition', 'error');
                })
            },
            saveData() {
                if (!this.form.detail_th) {
                    Swal('', 'Please insert Detail TH !', 'error');
                    return false;
                }
                if (!this.form.detail_en) {
                    Swal('', 'Please insert Detail EN !', 'error');
                    return false;
                }
                if (!this.form.template_id) {
                    Swal('', 'Please select Template !', 'error');
                    return false;
                }
                if (!this.form.publish_date) {
                    Swal('', 'Please select Publish Date !', 'error');
                    return false;
                }
                if (!this.form.cover_image_path) {
                    Swal('', 'Please select Cover Image !', 'error');
                    return false;
                }
                this.$store.dispatch("OnlineExhibition/saveOnlineExhibition", {
                    id: this.save_id ? this.save_id : this.form.id,
                    data: this.form
                }).then(res => {
                    this.save_id = res.result.id;
                    Swal(res.response_msg)
                }).catch(() => {
                    Swal('', 'Cannot save online exhibition', 'error');
                })
            },
            deleteData() {
                if (this.form.id) {
                    this.$store.dispatch("OnlineExhibition/deleteOnlineExhibition", this.form.id).then(res => {
                        Swal(res.response_msg)
                        if (res.response_code == 200) {
                            this.goToTable();
                        }
                    }).catch(() => {
                        Swal('', 'Cannot delete online exhibition', 'error');
                    });
                }
            },
            downloadUrl(url) {
                if (url) {
                    window.open(url, "_blank");
                } else {
                    Swal('', 'File not found for download', 'error');
                }
            },
            goToTable() {
                this.$router.push("/online-exhibition");
            },
            updateBranch(val) {
                this.form.branch_id = val;
            },
            updateTitleTH(val) {
                this.form.title_th = val;
            },
            updateTitleEN(val) {
                this.form.title_en = val;
            },
            updateDetailTH(val) {
                this.form.detail_th = val;
            },
            updateDetailEN(val) {
                this.form.detail_en = val;
            },
            updateSlugUrl(val) {
                this.form.slug_url = val;
            },
            updateAttachedWebsiteTH(val) {
                this.form.attached_website_th = val;
                this.form.display_attached_website_th = url + val;
            },
            updateAttachedWebsiteEN(val) {
                this.form.attached_website_en = val;
                this.form.display_attached_website_en = url + val;
            },
            updateTemplate(val) {
                this.form.template_id = val;
            },
            updatePublishDate(val) {
                this.form.publish_date = val
            },
            updateBackgroundColor(val) {
                this.form.background_color = val;
                this.modal = false;
            },
            updateCoverImageName(val) {
                this.form.cover_image_name = val;
            },
            updateCoverImage(val) {
                this.form.cover_image_path = val.fullImagePath;
                this.form.cover_image = val.imagePath;
            },
        }
    }
</script>

<style scoped>

  .file-uploads {
    overflow: hidden;
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .file-uploads.file-uploads-html4 input[type="file"] {
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .file-uploads.file-uploads-html5 input[type="file"] {
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
  .file-uploads.file-uploads-html5 {
    width: 100%;
    padding: 8px;
    background: white;
    border: #fb8c00 1px solid;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .custom-loader {
      animation: loader 1s infinite;
      display: flex;
  }
  @-moz-keyframes loader {
      from {
          transform: rotate(0);
      }
      to {
          transform: rotate(360deg);
      }
  }
  @-webkit-keyframes loader {
      from {
          transform: rotate(0);
      }
      to {
          transform: rotate(360deg);
      }
  }
  @-o-keyframes loader {
      from {
          transform: rotate(0);
      }
      to {
          transform: rotate(360deg);
      }
  }
  @keyframes loader {
      from {
          transform: rotate(0);
      }
      to {
          transform: rotate(360deg);
      }
  }
</style>
